import { BaseService } from './BaseService';
import type {
  AgentAttachmentDto,
  AttachAgentRequest,
  UpdateAgentAttachmentRequest,
} from '../types/agentAttachment';

class AgentAttachmentService extends BaseService {
  async getAttachments(parentId: string): Promise<AgentAttachmentDto[]> {
    return this.get<AgentAttachmentDto[]>(`/agents/${parentId}/attached-agents`);
  }

  async attach(parentId: string, data: AttachAgentRequest): Promise<AgentAttachmentDto> {
    return this.post<AgentAttachmentDto>(`/agents/${parentId}/attached-agents`, data);
  }

  async update(
    parentId: string,
    attachmentId: string,
    data: UpdateAgentAttachmentRequest,
  ): Promise<AgentAttachmentDto> {
    return this.put<AgentAttachmentDto>(
      `/agents/${parentId}/attached-agents/${attachmentId}`,
      data,
    );
  }

  async detach(parentId: string, attachmentId: string): Promise<void> {
    return this.delete<void>(`/agents/${parentId}/attached-agents/${attachmentId}`);
  }
}

export const agentAttachmentService = new AgentAttachmentService();
